module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-subscriptions"
  }, [_vm._m(0), _c('div', {
    staticClass: "tabs-inner-content client-subscriptions no-space"
  }, [_c('div', {
    directives: [{
      name: "f",
      rawName: "v-f"
    }],
    staticClass: "is-hidden",
    attrs: {
      "id": "create-subscription",
      "data-toggler": "is-hidden"
    }
  }, [_c('client-plan-subscriber', {
    attrs: {
      "client_id": _vm.$route.params.id
    },
    on: {
      "subscriptionAdded": _vm.subscriptionAdded
    }
  })], 1), _c('base-list', {
    ref: "tabbedList",
    attrs: {
      "dataLoader": _vm.dataLoader,
      "component": _vm.component
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("Client Subscriptions")])]), _c('div', {
    staticClass: "action"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x",
    attrs: {
      "data-toggle": "create-subscription"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-499b79c2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/ClientSubscriptions.vue
// module id = 2451
// module chunks = 1